import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function JointInjections() {
  useEffect(() => {
    document.title = "Joint Injections | Viksha Health Care";
    const newMetaDescription =
      "Joint injections at Viksha Health Care. Learn when injections may be recommended for pain and inflammation and how they fit into overall care.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>Joint Injections</h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/Joint-Injections.avif" />
        </div>
        <div className="textareaofser">
          <h1>Joint Injections</h1>

          <p>
            Joint injections are minimally invasive procedures used to relieve
            pain and inflammation in affected joints. They can help improve
            movement and make it easier to participate in rehabilitation and
            daily activities.
          </p>

          <p>
            These injections are often recommended when medications and
            physiotherapy alone do not provide sufficient relief.
          </p>

          <h5>Conditions That May Benefit from Joint Injections</h5>
          <ul>
            <li>Arthritis-related joint pain</li>
            <li>Inflammation of the joint lining</li>
            <li>Persistent joint swelling</li>
            <li>Pain following injury or overuse</li>
            <li>Shoulder, knee, hip, or ankle joint pain</li>
          </ul>

          <h5>Types of Joint Injections</h5>

          <h6>Anti-Inflammatory Injections</h6>
          <p>
            These injections help reduce inflammation within the joint and
            provide pain relief, allowing better joint movement.
          </p>

          <h6>Lubricating Injections (When Appropriate)</h6>
          <p>
            Some injections aim to improve joint lubrication and reduce friction
            in selected cases, especially in degenerative joint conditions.
          </p>

          <h5>Benefits of Joint Injections</h5>
          <ul>
            <li>Reduction in joint pain and swelling</li>
            <li>Improved range of motion</li>
            <li>Better participation in physiotherapy</li>
            <li>
              Delay or avoidance of more invasive treatments in some cases
            </li>
          </ul>

          <h5>How Joint Injections Support Recovery</h5>
          <p>
            By reducing pain and inflammation, injections make it easier to
            perform strengthening and flexibility exercises. This helps address
            the root cause of joint problems and improves long-term function.
          </p>

          <h5>What to Expect During the Procedure</h5>
          <p>
            Joint injections are usually done in an outpatient setting. The skin
            is cleaned, and the injection is given carefully into the affected
            joint. The procedure is generally quick and well tolerated.
          </p>

          <h5>Aftercare and Recovery</h5>
          <p>
            Mild soreness may occur for a short time after the injection.
            Patients are advised to avoid strenuous activity for a brief period
            and follow medical advice regarding exercises and rehabilitation.
          </p>

          <h5>Possible Temporary Effects</h5>
          <p>
            Some patients may experience temporary discomfort or mild swelling
            after the injection, which usually settles within a short time. Any
            unusual or persistent symptoms should be reported.
          </p>

          <h5>When to Consider Joint Injections</h5>
          <ul>
            <li>Persistent joint pain despite conservative treatment</li>
            <li>Inflammation limiting daily activities</li>
            <li>Difficulty performing physiotherapy due to pain</li>
            <li>Recurring flare-ups of joint symptoms</li>
          </ul>

          <p>
            Joint injections can provide targeted pain relief and support
            recovery, helping patients return to comfortable movement and
            improved quality of life.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(JointInjections);
